module.exports = __webpack_public_path__ + "media/images/common/lp/bg-presentAmazon-right-c896c211450f72caa937083b9b854979.png";